import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconPropertyHouseSvg } from "./IconPropertyHouseSvg.mjs";
const IconPropertyHouse = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconPropertyHouseSvg, ...iconProps });
};
export {
  IconPropertyHouse
};
